import React, { useState, useEffect } from "react";
import { Modal } from "flowbite-react";
import { useFileManager } from "../context/FileMangerContextHelper";
const CreateAndRenameFolderModal = ({
  openModal,
  setOpenModal,
  modalFor,
  folderId,
  _folderName,
}) => {

  const [folderName, setFolderName] = useState(_folderName || "");
  const { createUserFolder, renameUserFolder } = useFileManager();

  useEffect(() => {
    setFolderName(_folderName || "");
  }, [_folderName]);

  return (
    <>
      <Modal
        dismissible={true}
        show={openModal === "popup"}
        size={"md"}
        onClose={() => setOpenModal(undefined)}
      >
        <Modal.Header
          theme={{ title: "text-xl font-bold tracking-tight text-gray-900" }}
        >
          {modalFor === "create" ? "Create Folder" : "Rename Folder"}
        </Modal.Header>
        <Modal.Body>
          <div className="text-center">
            <div>
              <input
                type="text"
                id="folder_name"
                value={folderName}
                onChange={(e) => setFolderName(e.target.value)}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-[#c96b1a] focus:border-[#c96b1a] block w-full p-2.5"
                placeholder="Folder Name"
                required
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="flex justify-center gap-4">
            <button
              className="p-0.5 rounded-md bg-[#003464] text-center text-sm font-semibold text-white shadow-sm hover:bg-[#c96b1a] flex flex-row justify-between items-center hover:shadow-lg hover:ring-2 hover:ring-[#c96b1a]"
              onClick={() => {
                setOpenModal(undefined);
                if (modalFor === "create") {
                  createUserFolder(folderName);
                }else{
                  renameUserFolder(folderId,folderName)
                }
                setFolderName("")
              }}
            >
              <span className="flex items-center transition-all duration-200 rounded-md text-sm px-4 py-2">
                {modalFor === "create" ? "Create" : "Rename"}
              </span>
            </button>
            <button
              className="p-0.5 rounded-md bg-white text-center text-sm font-semibold text-black shadow-sm hover:text-[#c96b1a] flex flex-row justify-between items-center hover:shadow-lg hover:ring-2 hover:ring-[#c96b1a]"
              onClick={() => {
                setOpenModal(undefined);
              }}
            >
              <span className="flex items-center transition-all duration-200 rounded-md text-sm px-4 py-2">
                Cancel
              </span>
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default CreateAndRenameFolderModal;
